<template>
  <div>
    <h6><strong>Datos del Cliente</strong></h6>
    <div class="row">
      <div v-if="!esModoVista" class="col-xl-2">
        <div class="form-group mb-1">
          <label for="" class="form-label">Agencia:</label>
          <InputSelect v-model="cliente.agencia" :reduce="(opt) => opt.idAgencia" :options="containers.agencias" label="nombre" name="Agencia" vid="agencia" rules="required" :disabled="!esModoManual || estaFacturado"></InputSelect>
        </div>
        <div v-if="esModoAutomatico" class="form-group form-check">
          <input v-model="cliente.cambiarPorPasajero" type="checkbox" class="form-check-input" id="cambiarPorPasajero" :disabled="estaFacturado" />
          <label class="form-check-label" for="cambiarPorPasajero">Cambiar por pasajero</label>
        </div>
      </div>

      <div v-if="esOtroCliente || esModoVista" class="col-xl-2">
        <div class="form-group">
          <label for="" class="form-label">Denominación:</label>
          <InputText v-model="cliente.denominacion" name="Denominación" vid="denominacion" :rules="esOtroCliente ? 'required|max:100' : 'max:100'" :disabled="estaFacturado"></InputText>
        </div>
      </div>

      <div class="col-xl-2">
        <div class="form-group">
          <label for="" class="form-label">Tipo de Documento:</label>
          <InputSelect v-model="cliente.tipoDoc" :reduce="(opt) => opt.codigo" :options="containers.clienteTiposDoc" label="nombre" name="Tipo de Documento" vid="tipoDoc" rules="required" :disabled="disabledTipoDocumento"></InputSelect>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="form-group">
          <label for="" class="form-label">Número de Documento:</label>
          <InputText v-model="cliente.numeroDoc" name="Número de Documento" vid="numeroDoc" rules="required|max:15" :disabled="!esOtroCliente || estaFacturado"></InputText>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="form-group">
          <label for="" class="form-label">Dirección:</label>
          <InputText v-model="cliente.direccion" name="Dirección" vid="direccion" rules="required|max:100" :disabled="!esOtroCliente || estaFacturado"></InputText>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="form-group">
          <label for="" class="form-label">E-mail:</label>
          <InputText v-model="cliente.email" name="E-mail" vid="email" rules="email" :disabled="!esOtroCliente || estaFacturado"></InputText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputSelect from "../../shared/components/InputSelect.vue";
import InputText from "../../shared/components/InputText.vue";

import { mapGetters, mapState } from "vuex";

export default {
  components: { InputText, InputSelect },
  computed: {
    disabledTipoDocumento() {

      if (this.estaFacturado) {
        return true;
      }

      if (this.cliente.cambiarPorPasajero) return false;

      return !this.esModoManual || !this.esOtroCliente;
    },
    ...mapState("comprobante2", {
      cliente: (state) => state.cliente,
    }),
    ...mapGetters("comprobante2", ["containers", "esOtroCliente", "esModoVista", "esModoAutomatico", "esModoManual", "estaFacturado"]),
  },
};
</script>

<style></style>
